// extracted by mini-css-extract-plugin
export default {"mainContainer":"PrivacyPolicy_mainContainer__uhq5q","heading":"PrivacyPolicy_heading__SR0-Q","list":"PrivacyPolicy_list__O2IXZ"};